export const APP_VERSION = '0.11.395';
